import type { CSSProperties } from 'react';

export const filterPanelContainerStyle: CSSProperties = {
  width: '280px',
  flexShrink: 0,
};

export const filterBodyStyle: CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  overflow: 'hidden',
};

export const filterScrollAreaStyle: CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  overflowY: 'auto',
  padding: '16px',
  gap: '16px',
};

export const filterFooterStyle: CSSProperties = {
  display: 'flex',
  justifyContent: 'flex-end',
  padding: '12px 16px',
};

export const filterRangeRowStyle: CSSProperties = {
  display: 'flex',
  alignItems: 'flex-end',
  gap: '8px',
  width: '100%',
};

export const filterRangeSelectStyle: CSSProperties = {
  flex: 1,
  minWidth: 0,
  display: 'flex',
  flexDirection: 'column',
};

export const filterRangeToLabelStyle: CSSProperties = {
  fontFamily: 'Roboto, Arial, Helvetica, sans-serif',
  fontWeight: 400,
  fontSize: '14px',
  lineHeight: '1.43em',
  color: '#333333',
  height: '32px',
  display: 'flex',
  alignItems: 'center',
  flexShrink: 0,
};

export const selectedSectionStyle: CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
};

export const selectedLabelStyle: CSSProperties = {
  fontFamily: 'Roboto, Arial, Helvetica, sans-serif',
  fontSize: '13px',
  fontWeight: 500,
  color: '#333333',
};

export const chipsWrapStyle: CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  gap: '6px',
};

export const chipStyle: CSSProperties = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: '6px',
  padding: '4px 10px',
  borderRadius: '16px',
  backgroundColor: '#E8EEF5',
  fontSize: '13px',
  fontFamily: 'Roboto, Arial, Helvetica, sans-serif',
  color: '#333333',
  lineHeight: '20px',
  width: 'fit-content',
  maxWidth: '100%',
};

export const chipTextStyle: CSSProperties = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

export const chipRemoveStyle: CSSProperties = {
  background: 'none',
  border: 'none',
  cursor: 'pointer',
  padding: 0,
  fontSize: '11px',
  color: '#555555',
  lineHeight: 1,
  display: 'flex',
  alignItems: 'center',
  flexShrink: 0,
};

export const clearAllRowStyle: CSSProperties = {
  marginTop: '2px',
};

export const clearAllStyle: CSSProperties = {
  background: 'none',
  border: 'none',
  cursor: 'pointer',
  padding: 0,
  fontSize: '13px',
  fontFamily: 'Roboto, Arial, Helvetica, sans-serif',
  color: '#1A73E8',
};

export const selectedDividerStyle: CSSProperties = {
  border: 'none',
  borderTop: '1px solid #E0E0E0',
  margin: '4px 0 0 0',
};
